<template>
  <div v-if="!survey">Loading survey...</div>
  <SurveyComponent v-else :model="survey" />
</template>

<script>
import {LicenseEditorModel} from "@/models/LicenseEditorModel";
import {SurveyComponent} from "survey-vue3-ui";
import SurveyModel from "@/models/SurveyModel";

export default {
  components: {SurveyComponent},
  props: {
    model: {
      type: LicenseEditorModel,
      required: true
    },
    spacing: {
      type: Number,
      default: () => 1
    }
  },
  data() {
    return {
      survey: null
    };
  },
  mounted() {
    this.survey = SurveyModel.createFromLicenseEditor(this.model, {editable:false});
  }
}
</script>

<style>
.sd-root-modern .sd-container-modern .sd-body,
.sd-root-modern .sd-container-modern .sd-body .sd-page {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
